<template>
  <view class="layout-body">
    <sticky-header v-if="path !== '/privacyPolicy'"></sticky-header>
    <router-view></router-view>
  </view>
</template>

<script>
import stickyHeader from './components/common/sticky-header/sticky-header.vue'
import router from './router'
export default {
  name: 'App',
  components: {
    stickyHeader
  },
  data() {
    return {
      titleList: [],
      path: null
    }
  },
  watch: {},
  mounted() {
    const _this = this
    router.beforeEach((to, from, next) => {
      _this.path = to.path
      console.log('_this.path::', _this.path)
      next()
    })
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // width: 1200px;
  // margin: auto;
  // min-width: 1200px;
}

.layout-box {
  height: 100vh;
  overflow-y: auto;
}
</style>
